import type { IconData } from '@stacksjs/iconify-core'

export const pyramidShapeRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.082 3.062a4.853 4.853 0 0 1 7.836 0C31.961 8.538 40.51 20.539 46.81 32.327a5.796 5.796 0 0 1-2.695 8.012c-2.645 1.218-6.414 2.88-10.096 4.24c-3.57 1.32-7.388 2.487-10.002 2.492h-.034c-2.614-.005-6.432-1.173-10.003-2.492c-3.681-1.36-7.45-3.022-10.095-4.24a5.796 5.796 0 0 1-2.695-8.012C7.49 20.539 16.04 8.538 20.082 3.062M22 7.212v35.623c-1.78-.351-4.095-1.07-6.633-2.008c-3.542-1.31-7.206-2.922-9.81-4.121a1.796 1.796 0 0 1-.839-2.494C10.274 23.816 17.66 13.186 22 7.212\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pyramidShapeRemix
